import { render, staticRenderFns } from "./blockDatesPanel.vue?vue&type=template&id=3ad86bab&scoped=true&"
import script from "./blockDatesPanel.vue?vue&type=script&lang=js&"
export * from "./blockDatesPanel.vue?vue&type=script&lang=js&"
import style0 from "./blockDatesPanel.vue?vue&type=style&index=0&id=3ad86bab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad86bab",
  null
  
)

export default component.exports